import { render, staticRenderFns } from "./DrugInfo.vue?vue&type=template&id=0170187e&scoped=true&"
import script from "./DrugInfo.vue?vue&type=script&lang=js&"
export * from "./DrugInfo.vue?vue&type=script&lang=js&"
import style0 from "./DrugInfo.vue?vue&type=style&index=0&id=0170187e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0170187e",
  null
  
)

export default component.exports